import {Component, Input, OnInit} from '@angular/core';
import {ActionStatusType} from "../../../../common/enums/enums";

const ACTION_ICON_ASSET_PATH = `assets/images/issue-action-status/`;

/**
 * @Todo: extract to CommonAngular.
 * Since these icons were migrated over from the Building Manager
 * they are commmonto both projects and should be pulled up
 * into the CommonAngular package.
 */
@Component({
  selector: 'app-action-status-icon',
  templateUrl: './action-status-icon.component.html',
  styleUrls: ['./action-status-icon.component.css']
})
export class ActionStatusIconComponent {
  @Input()
  public icon: ActionStatusType;
//
  public get iconPath(): string {
    return `${ACTION_ICON_ASSET_PATH}${this.icon}.svg`;
  }
}
